import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled, { css } from 'styled-components';
import { ArrowDownFilledIcon } from '@deliveryhero/armor-icons';
import { transition, getComponentOverride, color, reset, spacing, propsBlocker } from '../../../system';
import { transitionDurationInSec } from '../../../constants';
export var DatePickerTopBarRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: ", " ", " 0 ", ";\n    ", ";\n"])), spacing(4), spacing(5), spacing(6), getComponentOverride('DatePickerTopBar'));

var getMonthYearSelectorToggleStyle = function getMonthYearSelectorToggleStyle(_ref) {
  var open = _ref.open;
  var result = {};

  if (open) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.04'));
  }

  return result;
};

export var DatePickerTopBarMonthYearSelectorToggle = styled.a.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    color: ", ";\n    ", ";\n    ", ";\n"])), reset(), color('neutral.06'), transition({
  color: 0.1
}), getMonthYearSelectorToggleStyle);

var getMonthYearSelectorToggleArrowStyle = function getMonthYearSelectorToggleArrowStyle(_ref2) {
  var open = _ref2.open;
  var result = {};

  if (open) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            transform: rotate(0.5turn);\n        "])), result);
  }

  return result;
};

export var DatePickerTopBarMonthYearSelectorToggleArrow = styled(ArrowDownFilledIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    transition: transform ", "s ease;\n    ", ";\n"])), transitionDurationInSec, getMonthYearSelectorToggleArrowStyle);
export var DatePickerTopBarMonthNavigation = styled.div.withConfig(propsBlocker)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: ", ";\n"])), reset(), color('neutral.06'));

var getMonthNavigationButtonForwardStyle = function getMonthNavigationButtonForwardStyle(_ref3) {
  var disabled = _ref3.disabled;
  var result = {};

  if (disabled) {
    result = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: initial;\n        "])), result, color('neutral.04'));
  }

  return result;
};

export var DatePickerTopBarMonthNavigationButtonForward = styled.button.withConfig(propsBlocker)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    border: 0 none;\n    appearance: none;\n    background-color: transparent;\n    color: ", ";\n\n    ", "\n"])), color('neutral.06'), getMonthNavigationButtonForwardStyle);
export var DatePickerTopBarMonthNavigationButtonBackward = styled(DatePickerTopBarMonthNavigationButtonForward)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    svg {\n        transform: rotate(0.5turn);\n    }\n    margin-right: ", ";\n"])), spacing(5));